/**
 * Values to map to Revenue Detail Page
 * key - the key that is used to pull and save data to GraphQl
 * label - Friendly label for the user
 */
const revenueFields = [
    {
        title: null,
        arr: [
            {
                key: 'affiliateName',
                label: "Affiliate Name",
                type: 'autoComplete',
                val: "allAffiliate",
                returnKey: 'name',
                displayKey: 'name',
                required: true
            },
        ]
    },
    {
        title: null,
        arr: [
            {
                key: 'trafficSourceName',
                label: "Traffic Source",
                type: 'autoComplete',
                val: "allTrafficSource",
                returnKey: 'name',
                displayKey: 'name',
                required: true
            },
        ]
    },
    {
        title: 'EVENT TIMESTAMPS',
        perRow: 2,
        arr: [
            {
                key: 'leadDate',
                label: 'Lead Date',
                type: 'dateTime',
                val: "",
                required: true
            },
            {
                key: 'billingDate',
                label: 'Billing Date',
                type: 'dateTime',
                val: "",
                required: true
            },
            {
                key: 'dateCreated',
                label: 'Date Created',
                type: 'date',
                val: "",
                required: false,
                disabled: true
            },
            {
                key: 'dateModified',
                label: 'Date Modified',
                type: 'date',
                val: "",
                required: false,
                disabled: true
            },
        ]
    },
    {
        title: 'REVENUE',
        perRow: 2,
        arr: [
            {
                key: 'revenueType',
                label: 'Type',
                type: 'autoComplete',
                val: "allRevenueType",
                returnKey: 'name',
                displayKey: 'name',
                required: true
            },
            {
                key: 'revenueClassification',
                label: 'Classification',
                type: 'autoComplete',
                val: "allRevenueClassification",
                returnKey: 'name',
                displayKey: 'name',
                required: true
            },
            {
                key: 'billed',
                label: 'Billed',
                type: 'text',
                inputType: 'number',
                val: "",
                required: true
            },
            {
                key: 'payout',
                label: 'Payout',
                type: 'text',
                inputType: 'number',
                val: "",
                required: true
            },
            {
                key: 'adjustmentTotalBilled',
                label: 'Adjustment Total Billed',
                type: 'text',
                inputType: 'number',
                val: "",
                required: false
            },
            {
                key: 'adjustmentTotalPayout',
                label: 'Adjustment Total Payout',
                type: 'text',
                inputType: 'number',
                val: "",
                required: false
            },
        ]
    },
    {
        title: 'EVERFLOW',
        perRow: 2,
        arr: [
            {
                key: 'everflowStatus',
                label: 'Status',
                type: 'autoComplete',
                val: "allRevenueEverflowStatus",
                defaultValue: 'COMPLETE',
                returnKey: 'name',
                displayKey: 'name',
                required: true
            },
            {
                key: 'everflowStatusExpiration',
                label: 'Status Expiration',
                type: 'dateTime',
                val: "",
                required: false
            },
            {
                key: 'everflowTransactionId',
                label: 'Transaction Id',
                type: 'text',
                val: "",
                required: false
            },
            {
                key: 'everflowAffiliateHash',
                label: 'Affiliate Hash',
                type: 'text',
                val: "",
                required: false
            },
            {
                key: 'everflowConversionId',
                label: 'Conversion Id',
                type: 'text',
                val: "",
                required: false
            },
            {
                key: 'everflowOfferHash',
                label: 'Offer Hash',
                type: 'text',
                val: "",
                required: false
            },
        ]
    },
    {
        title: 'Source Subcode',
        perRow: 2,
        arr: [
            {
                key: 'sourceSubCode1',
                label: 'Source SubCode 1',
                type: 'text',
                val: "",
                required: false
            },
            {
                key: 'sourceSubCode2',
                label: 'Source SubCode 2',
                type: 'text',
                val: "",
                required: false
            },
            {
                key: 'sourceSubCode3',
                label: 'Source SubCode 3',
                type: 'text',
                val: "",
                required: false
            },
            {
                key: 'sourceSubCode4',
                label: 'Source SubCode 4',
                type: 'text',
                val: "",
                required: false
            },
            {
                key: 'sourceSubCode5',
                label: 'Source SubCode 5',
                type: 'text',
                val: "",
                required: false
            },
        ]
    },
    {
        title: 'Advertiser',
        perRow: 2,
        arr: [
            {
                key: 'companyName',
                label: "Company Name",
                type: 'autoCompleteSimple',
                val: "allCompanies",
                returnKey: 'name',
                displayKey: 'name',
                required: true
            },
            {
                key: 'adv1',
                label: 'Adv1',
                type: 'text',
                val: "",
                required: false
            },
            {
                key: 'adv2',
                label: 'Adv2',
                type: 'text',
                val: "",
                required: false
            },
            {
                key: 'adv3',
                label: 'Adv3',
                type: 'text',
                val: "",
                required: false
            },
            {
                key: 'adv4',
                label: 'Adv4',
                type: 'text',
                val: "",
                required: false
            },
            {
                key: 'adv5',
                label: 'Adv5',
                type: 'text',
                val: "",
                required: false
            },
        ]
    },
    {
        title: 'Loan',
        perRow: 2,
        arr: [
            {
                key: 'formId',
                label: 'Form Id',
                type: 'text',
                val: "",
                required: false
            },
            {
                key: 'identityId',
                label: 'Identity Id',
                type: 'text',
                val: "",
                required: false
            },
            {
                key: 'loanRequestId',
                label: 'Loan Request Id',
                type: 'text',
                val: "",
                required: false
            },
            {
                key: 'loanResultId',
                label: 'Loan Result Id',
                type: 'text',
                val: "",
                required: false
            },
            {
                key: 'campaignDecisionLogId',
                label: 'Campaign Decision Id',
                type: 'text',
                val: "",
                required: false
            },
        ]
    },
    {
        title: 'AFFILIATE',
        perRow: 2,
        arr: [
            {
                key: 'clickBrowserId',
                label: 'Click Browser Id',
                type: 'text',
                val: "",
                required: false
            },
            {
                key: 'formFieldSubmitBrowserId',
                label: 'Form Field Submit Browser Id',
                type: 'text',
                val: "",
                required: false
            },
            {
                key: 'formFieldSubmitFieldId',
                label: 'Form Field Submit Field Id',
                type: 'text',
                val: "",
                required: false
            },
            {
                key: 'formSubmitBrowserId',
                label: 'Form Submit Browser Id',
                type: 'text',
                val: "",
                required: false
            },
            {
                key: 'formSubmitDataPackageType',
                label: 'Form Submit Data Package Type',
                type: 'autoComplete',
                val: "allDataPackageType",
                returnKey: 'name',
                displayKey: 'name',
                required: false
            }
        ]
    }
];

const adjustmentFields = [
    {
        key: 'payout',
        label: 'Payout',
        type: 'text',
        inputType: 'number',
        val: "",
        required: true
    },
    {
        key: 'billed',
        label: 'Billed',
        type: 'text',
        inputType: 'number',
        val: "",
        required: true
    },
    {
        key: 'reason',
        label: 'Reason',
        type: 'text',
        val: "",
        required: true
    },
    {
        key: 'adjustmentCategory',
        type: 'autoComplete',
        val: 'allAdjustmentCategory',
        label: 'Adjustment Category',
        returnKey: 'name',
        displayKey: 'name',
        required: true,
        fullWidth: false,
    },
    {
        key: 'adjustmentType',
        type: 'autoComplete',
        val: 'allAdjustmentType',
        label: 'Adjustment Type',
        returnKey: 'name',
        displayKey: 'name',
        required: true,
        fullWidth: false,
    },
];

export { revenueFields, adjustmentFields } ;

